import * as actionType from "./../constants/ActionTypes";

const initialState = {
    addUser: {
        formInfoLoaded: false,
        organisations: [],
        roles: [],
        userFormInfo: {
            fields: [],
        },
    },
};

/**
 * Returns the new state
 * @param {Object} state - state
 * @param {Object} action - action
 * @returns {{}} new state
 */
export default function addUserReducer(state = initialState, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case actionType.GET_FORM_INFO: {
            const { organisations, roles } = action;

            // clone state
            newState.addUser = { ...state.addUser };
            newState.addUser.organisations = [];
            newState.addUser.roles = [];

            // add received tree nodes to newState (if applicable, add received nodes as children of the parent on which the new node was added)
            Object.keys(organisations).forEach((organisationPath) => {
                const organisation = organisations[organisationPath];
                const pathParts = organisation.path.split("/");
                const slug = pathParts[pathParts.length - 1];

                newState.addUser.organisations.push({
                    depth: organisation.depth,
                    key: slug,
                    label: `${organisation.name}`,
                });
            });

            roles.forEach((role) => {
                newState.addUser.roles.push({
                    key: role.slug,
                    label: role.name,
                });
            });

            newState.addUser.formInfoLoaded = true;

            break;
        }

        case actionType.CLEAR_FORM_INFO: {
            newState.addUser = initialState.addUser;
            newState.addUser.organisations = [];
            newState.addUser.roles = [];
            newState.addUser.formInfoLoaded = false;

            break;
        }

        default:
            break;
    }

    return newState;
}
